import { useState, useCallback } from 'react';

import { localStorageService } from '../../utils/localStorage';
import { useIsHydrated } from '../../hooks';

const TELEGRAM_BANNER_STORAGE_KEY = 'telegramBannerClosed';

/**
 * Хук для управления видимостью Telegram баннера
 * Сохраняет состояние закрытия в localStorage
 */
export const useTelegramBannerVisibility = () => {
    const isHydrated = useIsHydrated();

    const [isVisible, setIsVisible] = useState(() => {
        return !localStorageService.exists(TELEGRAM_BANNER_STORAGE_KEY);
    });

    const handleClose = useCallback((e?: React.MouseEvent) => {
        e?.preventDefault();
        e?.stopPropagation();

        localStorageService.save(TELEGRAM_BANNER_STORAGE_KEY, true);
        setIsVisible(false);
    }, []);

    return { isVisible: isHydrated && isVisible, handleClose };
};
